import { Group } from 'three'
import { useNodeNeighborBaseFloorElevationReactiveMap } from '../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap'
import type { Engine } from '../../core/engine/Engine.type'
import type { EntityGraphNode } from '../../core/engine/EntityGraphNode/EntityGraphNode.type'
import type { ForestEntity } from '../../core/entity/EntityType/Forest'
import createForestTerrainClusterGroupV2Simple from '../objects/Trees/Forest/createForestTerrainClusterGroupV2Simple'

export default function createForestGroup(
  engine: Engine,
  ent: EntityGraphNode<ForestEntity>,
  callback: (group: Group) => void
): void {
  const neighborBaseElevationReactiveMap = useNodeNeighborBaseFloorElevationReactiveMap(engine)
  createForestTerrainClusterGroupV2Simple([ent], neighborBaseElevationReactiveMap).then(callback)
}
